<template>
  <div class="findinfo-slotcontainer flex_align_items_center flex_justify_center">
    <router-link to="/home">
      <img class="aplayz-logo-img" src="/media/images/logo/aplayz-logo-red.png" alt="aplayz-logo-red.png" />
    </router-link>

    <div class="max600-container">
      <slot name="findinfo-container"></slot>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style scoped src="@/assets/css/findinfoslot/findinfoslot.css"></style>
